export function changeBackgroundColor(element, color, textColorField = null) {
    element.style.backgroundColor = color;

    // Automatically adjust text color based on background brightness
    const c = color.substring(1);
    const rgb = Number.parseInt(c, 16);
    const r = (rgb >> 16) & 0xff;
    const g = (rgb >> 8) & 0xff;
    const b = (rgb >> 0) & 0xff;

    const brightness = (r + g + b) / 3;
    if (brightness > 128) {
        element.style.color = '#1c1c1c';
    } else {
        element.style.color = '#f7f7f7';
    }
}
